import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogConfiguration } from '@cupoui/shared/model/modal/modal-dialog-configuration';
import { SERVER_API_URL } from '../../../app.constants';

@Component({
    selector: 'jhi-video-stream-modal',
    templateUrl: './video-stream-modal.component.html',
    styleUrls: ['./video-stream-modal.component.scss'],
    standalone: false
})
export class VideoStreamModalComponent {
  modalDialogConfiguration: ModalDialogConfiguration;

  howToLoginVideoUrl: string;
  howToLoginVideoPosterUrl: string;

  private readonly videoServerStreamUrl = `${SERVER_API_URL}services/video/stream/`;
  private readonly videoServerThumbnailUrl = `${SERVER_API_URL}/services/video/thumbnail/`;

  constructor(public activeModal: NgbActiveModal) {}

  init(header: string, howToLoginVideoUrl: string, howToLoginVideoPosterUrl: string): void {
    this.modalDialogConfiguration = new ModalDialogConfiguration({
      headerText: header
    });
    this.howToLoginVideoUrl = `${this.videoServerStreamUrl}${howToLoginVideoUrl}`;
    this.howToLoginVideoPosterUrl = `${this.videoServerThumbnailUrl}${howToLoginVideoPosterUrl}`;
  }
}
